<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height column  ma-0 pt-0 >
        
        <scroll-area>

          <template slot="header">

            <v-toolbar class="active" :height="44" flat dark>
              <v-toolbar-title>
                <span class="body-2 uppercase blacktext--text">{{ $t('e-mail') }}</span>
              </v-toolbar-title>

              <v-layout fill-height justify-end align-center>

                <v-tooltip v-if="edit" dark color="secondary" bottom>
                  <v-btn icon flat slot="activator" 
                  :data-testid="$options.name + '__btn__' + 'submit'"
                  @click="() => submit()">
                    <svg-icon
                      :color="'blacktext'"
                      :name="'done'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('save') }}</span>
                </v-tooltip>

                <v-tooltip v-if="!edit" dark color="secondary" bottom>
                  <v-btn icon flat slot="activator" 
                  :data-testid="$options.name + '__btn__' + 'edit'"
                  @click="() => {edit = !edit}">
                    <svg-icon
                      :color="'blacktext'"
                      :name="'edit'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('edit') }}</span>
                </v-tooltip>

                <v-tooltip v-if="edit" dark color="secondary" bottom>
                  <v-btn icon flat slot="activator" 
                  :data-testid="$options.name + '__btn__' + 'cancelEdit'"
                  @click="() => cancelEdit()">
                    <svg-icon
                      :color="'blacktext'"
                      :name="'close'"
                      width="20"
                    />
                  </v-btn>
                  <span>{{ $t('cancel') }}</span>
                </v-tooltip>

              </v-layout>

            </v-toolbar>

          </template>
          
          <template slot="body">

            <v-layout fill-height justify-start ma-0 px-1 >

              <v-layout column fill-height justify-start ma-0 py-1 >

                <v-toolbar 
                  :height="44"
                  class="active" 
                  flat
                  prominent
                  @click.stop=""
                >
                  <v-toolbar-title>
                    <span class="body-2 uppercase blacktext--text"> {{$t('common')}} </span>
                  </v-toolbar-title>

                </v-toolbar>

                <v-layout column fill-height justify-start ma-0 pt-1 >

                  <v-layout v-for="(field, name) in getFields" :key= " 'common' + name" shrink pa-0 ma-0>

                    <v-layout v-if="field.show == 'true' && (field.type == 'text' || field.type == 'integer') && field.group == 'common'"   pb-1>
                      <v-flex xs6  pa-0>
                        <v-text-field 
                          :value="$t(field.name)"
                          light
                          outline
                          flat
                          readonly
                          disabled
                          class="backgrey"
                          hide-details
                          :rows="1"
                          color="white"
                        >                   
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12  pa-0>                          
                        <v-text-field
                          :data-testid="$options.name + '__common_text-field__' + field.name"
                          v-model="model.obj[field.name]"
                          light                   
                          outline
                          :readonly="!edit"
                          class="white"                         
                          hide-details
                          :rows="1"
                          color="accent"
                        >                     
                        </v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout v-if="field.show == 'true' && field.type == 'boolean' && field.group == 'common'"  shrink pa-0>
                      
                      <v-checkbox
                        :readonly="!edit"
                        small
                        light
                        color="active"
                        :data-testid="$options.name + '__common_checkbox__' + field.name"
                        v-model="model.obj[field.name]"
                      >
                        <template v-slot:label>
                          <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                          <span class="black--text" v-else>{{$t(field.name)}}</span>
                        </template>
                      </v-checkbox>

                    </v-layout>

                    <v-layout v-if="field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.group == 'common'"  pa-0>

                      <v-flex xs6  pa-0>
                              
                        <v-text-field
                          :value="$t(field.name)"
                          light
                          outline                       
                          readonly
                          disabled
                          class="backgrey"
                          hide-details
                          :rows="1"
                          color="white"
                        >

                        </v-text-field>

                      </v-flex>

                      <v-flex xs12  px-0>

                        <v-select
                          :data-testid="$options.name + '__common_select__' + field.name"
                          v-model="model.obj[field.name]"
                          light
                          :items="getItems[field.cls]"
                          :item-text="field.type == 'select' ? 'name' : 'value'"
                          :item-value="field.type == 'select' ? '$id' : 'id'"    
                          :readonly="!edit"
                          outline
                          hide-details
                          flat
                          class="white"
                          background-color="backgrey"
                          clearable
                        >
                          <template v-slot:item="{ item, index }">
                              <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                          </template>
                          <template v-slot:selection="{ item, index }">
                              <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                          </template>
                        </v-select>

                      </v-flex>

                    </v-layout>
                  </v-layout>
                </v-layout>

                <v-tooltip v-if="!edit" dark color="secondary" right>                
                  <v-btn flat class="primary" slot="activator" outline small 
                  :data-testid="$options.name + '__common_btn__' + 'test'"
                  @click="() => {dialog.eMail.open = !dialog.eMail.open}">
                    <span class="primary--text">{{ $t('test') }}</span>
                  </v-btn>
                  <span>{{ $t('test') }}</span>
                </v-tooltip>

              </v-layout>
              <v-layout column fill-height justify-start ma-0 pa-1 >

                <v-toolbar 
                  :height="44"
                  class="active" 
                  flat
                  prominent
                  @click.stop=""
                >
                  <v-toolbar-title>
                    <span class="body-2 uppercase blacktext--text"> {{$t('TLS')}}  </span>
                  </v-toolbar-title>

                </v-toolbar>

                <v-layout column fill-height justify-start ma-0 pt-1 >

                  <v-layout v-for="(field, name) in getFields" :key= "'tls' + name" shrink pa-0 ma-0>

                    <v-layout v-if="field.show == 'true' && (field.type == 'text' || field.type == 'integer') && field.group == 'tls'" pb-1>
                      <v-flex xs6  pa-0>

                        <v-text-field 
                          :value="$t(field.name)"
                          light
                          outline
                          readonly
                          disabled
                          class="backgrey"
                          hide-details
                          :rows="1"
                          color="white"
                        >                   
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12  pa-0>                          
                        <v-text-field
                          :data-testid="$options.name + '__TLS_text-field__' + field.name"
                          v-model="model.obj[field.name]"
                          light        
                          outline
                          flat
                          :readonly="!edit"
                          class="white"                         
                          hide-details
                          :rows="1"
                          color="accent"
                        >                     
                        </v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout v-if="field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.group == 'tls'"  pb-1>

                      <v-flex xs6  pa-0>
                              
                        <v-text-field
                          :value="$t(field.name)"
                          light                        
                          outline
                          readonly
                          disabled
                          class="backgrey"                          
                          hide-details
                          :rows="1"
                          color="white"
                        >

                        </v-text-field>

                      </v-flex>

                      <v-flex xs12   px-0>

                        <v-select
                          :data-testid="$options.name + '__TLS_select__' + field.name"
                          v-model="model.obj[field.name]"
                          light
                          :items="getItems[field.cls]"
                          :item-text="field.type == 'select' ? 'name' : 'value'"
                          :item-value="field.type == 'select' ? '$id' : 'id'"                    
                          :readonly="!edit"
                          outline
                          hide-details
                          flat
                          class="white"
                          background-color="backgrey"
                          clearable
                        >
                          <template v-slot:item="{ item, index }">
                              <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                          </template>
                          <template v-slot:selection="{ item, index }">
                              <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                          </template>
                        </v-select>

                      </v-flex>

                    </v-layout>

                    <v-layout v-if="field.show == 'true' && field.type == 'boolean' && field.group == 'tls'"  shrink pa-0>
                      
                      <v-checkbox
                        :readonly="!edit"
                        :disabled="!edit"
                        small
                        light
                        color="active"
                        :data-testid="$options.name + '__TLS_checkbox__' + field.name"
                        v-model="model.obj[field.name]"
                      >
                        <template v-slot:label>
                          <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                          <span class="black--text" v-else>{{$t(field.name)}}</span>
                        </template>
                      </v-checkbox>

                    </v-layout>

                  </v-layout>
                </v-layout>

              </v-layout>
              <v-layout column fill-height justify-start ma-0 py-1 >

                <v-toolbar 
                  :height="44"
                  class="active" 
                  flat
                  prominent
                  @click.stop=""
                >
                  <v-toolbar-title>
                    <span class="body-2 uppercase blacktext--text"> {{$t('auth')}} </span>
                  </v-toolbar-title>

                </v-toolbar>

                <v-layout column fill-height justify-start ma-0 pt-1 >

                  <v-layout v-for="(field, name) in getFields" :key= " 'auth' + name" shrink pa-0 ma-0>

                    <v-layout v-if="field.show == 'true' && (field.type == 'text' || field.type == 'integer') && field.group == 'auth'"   pa-0 pb-1>
                      <v-flex xs6  pa-0>
                        <v-text-field 
                          :value="$t(field.name)"
                          light
                          outline
                          flat
                          readonly
                          disabled
                          class="backgrey"
                          hide-details
                          :rows="1"
                          color="white"
                        >                   
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 shrink pa-0>                          
                        <v-text-field
                          :data-testid="$options.name + '__auth_text-field__' + field.name"
                          v-model="model.obj[field.name]"
                          :type="field.hide_pass ? 'password' : 'text'"
                          light                   
                          outline                       
                          :readonly="!edit"
                          class="white"                        
                          hide-details
                          :rows="1"
                          color="accent"
                        >                     
                        </v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout v-if="field.show == 'true' && (field.type == 'select' || field.type == 'select_enum') && field.group == 'auth'"  pb-1>

                      <v-flex xs6 pa-0>
                              
                        <v-text-field
                          light
                          :value="$t(field.name)"
                          outline   
                          flat
                          readonly
                          disabled
                          class="backgrey"                    
                          hide-details
                          :rows="1"
                          color="white"
                        >

                        </v-text-field>

                      </v-flex>

                      <v-flex xs12 px-0>

                        <v-select
                          :data-testid="$options.name + '__auth_select__' + field.name"
                          v-model="model.obj[field.name]"
                          light
                          :items="getItems[field.cls]"
                          :item-text="field.type == 'select' ? 'name' : 'value'"
                          :item-value="field.type == 'select' ? '$id' : 'id'"                     
                          :readonly="!edit"
                          outline
                          hide-details
                          flat
                          class="white"
                          background-color="backgrey"
                          clearable
                        >
                          <template v-slot:item="{ item, index }">
                              <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                          </template>
                          <template v-slot:selection="{ item, index }">
                              <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                          </template>
                        </v-select>

                      </v-flex>

                    </v-layout>

                    <v-layout v-if="field.show == 'true' && field.type == 'boolean' && field.group == 'auth'"  shrink pa-0>
                      
                      <v-checkbox
                        :readonly="!edit"
                        :disabled="!edit"
                        small
                        light
                        color="active"
                        :data-testid="$options.name + '__auth_checkbox__' + field.name"
                        v-model="model.obj[field.name]"
                      >
                        <template v-slot:label>
                          <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                          <span class="black--text" v-else>{{$t(field.name)}}</span>
                        </template>
                      </v-checkbox>

                    </v-layout>
                  </v-layout>
                </v-layout>

              </v-layout>

            </v-layout>

          </template>

        </scroll-area>

      </v-layout>

      <v-dialog persistent v-model="dialog.eMail.open" max-width="800px" v-if="dialog.eMail.open">
        <e-mail-card
          @close="() => {dialog.eMail.open = !dialog.eMail.open}"
        />
    </v-dialog>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { CCMDBObject } from '@entcor/ebridge'
import eMailCard from '@/nms/pages/configuration/components/e-mail-card.vue'

// Типы
interface ModelData {
  obj: Record<string, any>
  fields: Record<string, any>
  items?: Record<string, any>
}

interface MetaData {
  [key: string]: any
}

interface EmailNotifierData {
  $id?: string
  _cmdb_?: boolean
  [key: string]: any
}

interface DialogState {
  eMail: {
    open: boolean
  }
}

export default Vue.extend({
  name: 'NOTIFICATIONS_SMTP',

  components: {
    scrollArea,
    scrollTable,
    svgIcon,
    eMailCard
  },

  props: {},

  data(): {
    meta: MetaData | null
    data: EmailNotifierData | null
    edit: boolean
    model: ModelData
    dialog: DialogState
  } {
    return {
      meta: null,
      data: null,
      edit: false,
      model: {
        obj: {},
        fields: {}
      },
      dialog: {
        eMail: { open: false },
      },
    }
  },

  computed: {
    getData(): EmailNotifierData | null {
      return this.data
    },

    getObj(): Record<string, any> {
      return this.model.obj
    },

    getFields(): Record<string, any> {
      return this.model.fields
    },

    getItems(): Record<string, any> | undefined {
      return this.model.items
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.loadMeta()
    },

    async loadMeta(caller?: string): Promise<void> {
      try {
        const objects = await this.$bridge.getObjectsByClass('email_notifier')
        if (objects?.length) {
          this.data = objects[0]
        }

        this.meta = await this.$loadMeta('email_notifier')
        console.log(this.$options.name, 'loadMeta', 'caller', caller, 'this.meta', this.meta)

        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          if (this.getData) {
            await this.prepareData()
          }
        }
      } catch (error) {
        console.error(this.$options.name, 'loadMeta smth wrong', error)
      }
    },

    async prepareData(): Promise<void> {
      try {
        const model = await this.$prepareData(this.model, this.getData, this.meta)
        console.log(this.$options.name, 'prepareData', 'model', model)
        this.model = model

        if (this.getData?.$id) {
          this.$set(this.model.fields, '$id', this.getData.$id)
        }
      } catch (error) {
        this.setLoader('prepareData', false)
        console.error('CATCH', this.$options.name, 'prepareData', 'SMTH WRONG', error)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    async cancelEdit(): Promise<void> {
      this.edit = false
      await this.setup()
    },

    async submit(): Promise<void> {
      try {
        if (!this.data) return
        this.setLoader('submit', true)

        const obj = this.data._cmdb_ ? this.data : new CCMDBObject({ ...this.data })
        const u = await obj.update(this.model.obj)
        console.log(this.$options.name, 'submit', 'updated', u)

        this.setLoader('submit', false)
        this.$dialog.notify.success('Параметры успешно обновлены', { timeout: 5000 })
        this.edit = false
        await this.setup()
      } catch (error) {
        console.error(this.$options.name, 'submit smth wrong', error)
        this.setLoader('submit', false)
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
